/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import styles from "./scss/testimonialSlider.module.scss";
import leaf from "assets/images/v2/leafPatterNew.webp";
import fort from "assets/images/v2/fortImage.webp";
import { EmployeesContent, studentContent } from "./TestimonialData";
import { mediaBreakpoint } from "globals/utils/globalVariables";
import { LazyLoadImage } from "react-lazy-load-image-component";

const TestimonialSlider = ({ t }) => {
  const [activeContent, setactiveContent] = useState("employees");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [imageIndex, setImageIndex] = useState(0);
  const [activeAnimation, setActiveAnimation] = useState(false);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const updateDimensions = () => {
    setWindowWidth(window.innerWidth);
  };
  const isResponsive =
    windowWidth < mediaBreakpoint.mobile ||
    windowWidth < mediaBreakpoint.bigTablet;

  const arrow = (direction) => (
    <svg
      width="32"
      height="40"
      viewBox="0 0 32 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`scale${direction === "right" ? "(1 , 1)" : "(-1, 1)"}`}
    >
      <path
        d="M2.71094 2.57812L27.8394 28.5236L2.71094 54.4722"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );

  const handleActiveContainer = (type) => {
    if (activeContent !== type) {
      setactiveContent(type);
      setImageIndex(0);
      setActiveAnimation(false);
    }
  };

  const generateTitleContainer = (type, label) => (
    <div
      key={type}
      className={`${styles.titleContainer} ${
        activeContent === type && styles.activeContent
      } ${styles.menuContainer}`}
    >
      <h4 onClickCapture={() => handleActiveContainer(type)}>
        {label}
        {activeContent === type && <span className={styles.activeDot}></span>}
      </h4>
      <span
        className={`${styles.gradientLine} ${
          activeContent !== type && styles.hideLine
        }`}
      ></span>
    </div>
  );

  const slideImage = (index) => {
    let indexValue;

    if (index === EmployeesContent.length) {
      indexValue = 0;
    } else if (index < 0) {
      indexValue = EmployeesContent.length - 1;
    } else {
      indexValue = index;
    }
    setActiveAnimation(true);
    setImageIndex(indexValue);
  };

  const updateClick = (direction) => {
    const sliderContent =
      activeContent === "employees" ? EmployeesContent : studentContent;
    const disableNextBtnDesktop = !(sliderContent.length / 2 <= imageIndex + 1);
    const disableNextBtn = isResponsive
      ? sliderContent.length !== imageIndex + 1
      : disableNextBtnDesktop;
    let newIndex = imageIndex;
    if (direction === "next" && disableNextBtn) {
      newIndex = imageIndex + 1;
    }
    if (direction === "prev" && imageIndex !== 0) {
      newIndex = imageIndex - 1;
    }
    slideImage(newIndex);
  };

  const card = (content) => {
    return content?.map((item, index) => {
      const singleContentClass =
        content.length % 2 !== 0 &&
        content.length === index + 1 &&
        !isResponsive;
      const studentContent = activeContent === "students";
      return (
        <div
          key={index}
          className={`${styles.EmployeesContent} ${
            singleContentClass && styles.singleContent
          } ${studentContent && styles.studentcontentWrapper}`}
        >
          {activeContent === "employees" && (
            <div className={styles.imageContainer}>
              <LazyLoadImage alt="reviewerImg" src={item.photo} />
            </div>
          )}
          {(index % 2 === 0 || isResponsive) && studentContent && (
            <span className={styles.contentTopBorder}></span>
          )}
          {(index % 2 !== 0 ||
            singleContentClass ||
            (isResponsive && studentContent)) && (
            <span className={styles.contentBottomBorder}></span>
          )}
          <div
            className={`${styles.cardContent} 
            ${studentContent && styles.studentContent}`}
          >
            <div className={styles.reviewInfo}>
              <h4>{item.title}</h4>
              <span className={styles.line}></span>
              <span className={styles.smallLine}></span>
              <p>{item.description}</p>
            </div>
            {activeContent !== "employees" && (
              <h2 className={styles.profession}>{item.profession}</h2>
            )}
            {activeContent === "employees" && (
              <div>
                <h2 className={styles.userName}>{item.name}</h2>
                <p>{item.profession}</p>
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  const renderSlider = () => {
    const sliderContent =
      activeContent === "employees" ? EmployeesContent : studentContent;
    const disableNextBtnDesktop = !(sliderContent.length / 2 <= imageIndex + 1);
    const disableNextBtn = !isResponsive
      ? disableNextBtnDesktop
      : sliderContent.length !== imageIndex + 1;
    return (
      <div className={styles.sliderContainer}>
        <div
          className={`${styles.sliderBtnLeft} ${
            imageIndex === 0 && styles.disabled
          }`}
          onClick={() => updateClick("prev")}
        >
          {arrow("left")}
        </div>
        <div
          className={`${styles["image-container"]} ${
            activeContent !== "employees" && styles.studentContainer
          } `}
        >
          <div
            className={`${styles.carousel} ${
              activeAnimation && styles.addAnimation
            }`}
            style={{
              transform: `translateX(-${imageIndex * 100}%)`,
            }}
          >
            {card(sliderContent)}
          </div>
        </div>
        <div
          className={`${styles.sliderBtn} ${
            !disableNextBtn && styles.disabled
          }`}
          onClick={() => updateClick("next")}
        >
          {arrow("right")}
        </div>
      </div>
    );
  };

  const backgroundText = () => (
    <>
      <svg
        width="1158"
        height="143"
        viewBox="0 0 1158 143"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.1"
          d="M95.4287 18.2012V42.2378H62.7949L62.7949 141.367H32.793L32.793 42.2378H0.15923L0.15923 18.2012L95.4287 18.2012ZM202.773 90.8375C202.773 93.6447 202.597 96.5689 202.246 99.61H134.347C134.815 105.692 136.745 110.371 140.137 113.646C143.646 116.804 147.915 118.383 152.945 118.383C160.431 118.383 165.636 115.225 168.56 108.909H200.492C198.854 115.342 195.872 121.132 191.544 126.278C187.333 131.425 182.011 135.46 175.578 138.385C169.145 141.309 161.951 142.771 153.998 142.771C144.406 142.771 135.868 140.724 128.382 136.63C120.896 132.536 115.048 126.688 110.837 119.085C106.626 111.482 104.521 102.593 104.521 92.4166C104.521 82.2405 106.567 73.351 110.661 65.7482C114.872 58.1453 120.72 52.297 128.206 48.2031C135.692 44.1093 144.289 42.0624 153.998 42.0624C163.472 42.0624 171.893 44.0508 179.262 48.0277C186.631 52.0046 192.363 57.6774 196.456 65.0464C200.667 72.4153 202.773 81.0123 202.773 90.8375ZM172.069 82.9423C172.069 77.7957 170.314 73.7019 166.805 70.6608C163.296 67.6196 158.91 66.0991 153.647 66.0991C148.617 66.0991 144.348 67.5611 140.839 70.4853C137.447 73.4095 135.341 77.5618 134.523 82.9423H172.069ZM258.427 142.771C249.889 142.771 242.286 141.309 235.619 138.385C228.952 135.46 223.688 131.483 219.828 126.454C215.968 121.307 213.805 115.576 213.337 109.26H242.988C243.339 112.652 244.918 115.401 247.725 117.506C250.532 119.611 253.983 120.664 258.076 120.664C261.819 120.664 264.685 119.962 266.674 118.559C268.779 117.038 269.832 115.108 269.832 112.769C269.832 109.962 268.37 107.915 265.445 106.628C262.521 105.224 257.784 103.704 251.234 102.066C244.216 100.429 238.368 98.7328 233.689 96.9783C229.01 95.1068 224.975 92.2411 221.583 88.3812C218.191 84.4044 216.495 79.0824 216.495 72.4153C216.495 66.8009 218.015 61.7128 221.056 57.1511C224.215 52.4724 228.776 48.788 234.742 46.0977C240.824 43.4075 248.017 42.0624 256.322 42.0624C268.603 42.0624 278.253 45.1035 285.271 51.1858C292.406 57.2681 296.5 65.3388 297.553 75.3979H269.832C269.364 72.0059 267.843 69.3156 265.27 67.3272C262.814 65.3388 259.539 64.3446 255.445 64.3446C251.936 64.3446 249.245 65.0464 247.374 66.45C245.503 67.7366 244.567 69.5496 244.567 71.8889C244.567 74.6961 246.029 76.8015 248.953 78.2051C251.994 79.6087 256.673 81.0123 262.989 82.4159C270.241 84.2874 276.148 86.1589 280.71 88.0303C285.271 89.7848 289.248 92.709 292.64 96.8028C296.149 100.78 297.962 106.16 298.079 112.944C298.079 118.676 296.442 123.822 293.167 128.384C290.008 132.829 285.388 136.338 279.306 138.911C273.341 141.484 266.381 142.771 258.427 142.771ZM370.999 115.927L370.999 141.367H355.735C344.857 141.367 336.377 138.735 330.295 133.472C324.213 128.091 321.171 119.377 321.171 107.33V68.3799H309.241V43.466H321.171V19.6048H351.173V43.466H370.824V68.3799H351.173V107.681C351.173 110.605 351.875 112.71 353.279 113.997C354.682 115.284 357.022 115.927 360.297 115.927H370.999ZM402.8 33.2899C397.536 33.2899 393.208 31.7693 389.816 28.7282C386.541 25.5701 384.904 21.7102 384.904 17.1485C384.904 12.4698 386.541 8.60988 389.816 5.56874C393.208 2.41064 397.536 0.831583 402.8 0.831583C407.946 0.831583 412.157 2.41064 415.432 5.56874C418.824 8.60988 420.52 12.4698 420.52 17.1485C420.52 21.7102 418.824 25.5701 415.432 28.7282C412.157 31.7693 407.946 33.2899 402.8 33.2899ZM417.713 43.466L417.713 141.367H387.711L387.711 43.466L417.713 43.466ZM564.375 42.4133C576.54 42.4133 586.19 46.0977 593.325 53.4666C600.577 60.8355 604.203 71.0701 604.203 84.1704V141.367H574.376V88.2058C574.376 81.8896 572.68 77.0355 569.288 73.6434C566.013 70.1344 561.451 68.3799 555.603 68.3799C549.755 68.3799 545.134 70.1344 541.742 73.6434C538.467 77.0355 536.83 81.8896 536.83 88.2058V141.367H507.003L507.003 88.2058C507.003 81.8896 505.307 77.0355 501.915 73.6434C498.64 70.1344 494.078 68.3799 488.23 68.3799C482.382 68.3799 477.762 70.1344 474.37 73.6434C471.094 77.0355 469.457 81.8896 469.457 88.2058L469.457 141.367H439.455L439.455 43.466H469.457V55.7475C472.498 51.6537 476.475 48.4371 481.388 46.0977C486.3 43.6414 491.856 42.4133 498.055 42.4133C505.424 42.4133 511.974 43.9923 517.706 47.1504C523.554 50.3085 528.116 54.8118 531.391 60.6601C534.783 55.2796 539.403 50.8934 545.251 47.5013C551.1 44.1093 557.474 42.4133 564.375 42.4133ZM669.75 142.771C660.158 142.771 651.503 140.724 643.783 136.63C636.18 132.536 630.156 126.688 625.712 119.085C621.384 111.482 619.22 102.593 619.22 92.4166C619.22 82.3574 621.442 73.5264 625.887 65.9236C630.332 58.2038 636.414 52.297 644.134 48.2031C651.854 44.1093 660.509 42.0624 670.101 42.0624C679.692 42.0624 688.347 44.1093 696.067 48.2031C703.787 52.297 709.869 58.2038 714.314 65.9236C718.759 73.5264 720.981 82.3574 720.981 92.4166C720.981 102.476 718.7 111.365 714.139 119.085C709.694 126.688 703.553 132.536 695.716 136.63C687.997 140.724 679.341 142.771 669.75 142.771ZM669.75 116.804C675.481 116.804 680.335 114.699 684.312 110.488C688.406 106.277 690.453 100.253 690.453 92.4166C690.453 84.5798 688.464 78.556 684.488 74.3452C680.628 70.1344 675.832 68.029 670.101 68.029C664.252 68.029 659.398 70.1344 655.538 74.3452C651.678 78.4391 649.748 84.4628 649.748 92.4166C649.748 100.253 651.62 106.277 655.363 110.488C659.223 114.699 664.018 116.804 669.75 116.804ZM796.551 42.4133C808.014 42.4133 817.137 46.1562 823.921 53.6421C830.822 61.011 834.273 71.1871 834.273 84.1704V141.367H804.446V88.2058C804.446 81.6556 802.75 76.5676 799.358 72.9416C795.966 69.3156 791.404 67.5027 785.673 67.5027C779.942 67.5027 775.38 69.3156 771.988 72.9416C768.596 76.5676 766.9 81.6556 766.9 88.2058V141.367H736.898V43.466L766.9 43.466V56.4493C769.941 52.1215 774.035 48.7295 779.181 46.2732C784.328 43.6999 790.118 42.4133 796.551 42.4133ZM870.21 33.2899C864.946 33.2899 860.619 31.7693 857.227 28.7282C853.951 25.5701 852.314 21.7102 852.314 17.1485C852.314 12.4698 853.951 8.60988 857.227 5.56874C860.619 2.41064 864.946 0.831583 870.21 0.831583C875.356 0.831583 879.567 2.41064 882.842 5.56874C886.234 8.60988 887.93 12.4698 887.93 17.1485C887.93 21.7102 886.234 25.5701 882.842 28.7282C879.567 31.7693 875.356 33.2899 870.21 33.2899ZM885.123 43.466V141.367H855.121V43.466H885.123ZM900.9 92.2411C900.9 82.182 902.771 73.351 906.514 65.7482C910.374 58.1453 915.579 52.297 922.129 48.2031C928.68 44.1093 935.99 42.0624 944.061 42.0624C950.962 42.0624 956.985 43.466 962.132 46.2732C967.396 49.0804 971.431 52.7648 974.238 57.3265V43.466H1004.24V141.367H974.238V127.507C971.314 132.068 967.22 135.753 961.957 138.56C956.81 141.367 950.786 142.771 943.885 142.771C935.931 142.771 928.68 140.724 922.129 136.63C915.579 132.419 910.374 126.512 906.514 118.91C902.771 111.19 900.9 102.3 900.9 92.2411ZM974.238 92.4166C974.238 84.9307 972.133 79.0239 967.922 74.6961C963.828 70.3683 958.798 68.2045 952.833 68.2045C946.868 68.2045 941.78 70.3683 937.569 74.6961C933.475 78.9069 931.428 84.7553 931.428 92.2411C931.428 99.727 933.475 105.692 937.569 110.137C941.78 114.465 946.868 116.629 952.833 116.629C958.798 116.629 963.828 114.465 967.922 110.137C972.133 105.809 974.238 99.9025 974.238 92.4166ZM1055.95 11.5341V141.367H1025.95V11.5341L1055.95 11.5341ZM1117.52 142.771C1108.98 142.771 1101.37 141.309 1094.71 138.385C1088.04 135.46 1082.78 131.483 1078.92 126.454C1075.06 121.307 1072.89 115.576 1072.43 109.26H1102.08C1102.43 112.652 1104.01 115.401 1106.81 117.506C1109.62 119.611 1113.07 120.664 1117.17 120.664C1120.91 120.664 1123.77 119.962 1125.76 118.559C1127.87 117.038 1128.92 115.108 1128.92 112.769C1128.92 109.962 1127.46 107.915 1124.53 106.628C1121.61 105.224 1116.87 103.704 1110.32 102.066C1103.3 100.429 1097.46 98.7328 1092.78 96.9783C1088.1 95.1068 1084.06 92.2411 1080.67 88.3812C1077.28 84.4044 1075.58 79.0824 1075.58 72.4153C1075.58 66.8009 1077.1 61.7128 1080.15 57.1511C1083.3 52.4724 1087.87 48.788 1093.83 46.0977C1099.91 43.4075 1107.11 42.0624 1115.41 42.0624C1127.69 42.0624 1137.34 45.1035 1144.36 51.1858C1151.5 57.2681 1155.59 65.3388 1156.64 75.3979H1128.92C1128.45 72.0059 1126.93 69.3156 1124.36 67.3272C1121.9 65.3388 1118.63 64.3446 1114.53 64.3446C1111.02 64.3446 1108.33 65.0464 1106.46 66.45C1104.59 67.7366 1103.66 69.5496 1103.66 71.8889C1103.66 74.6961 1105.12 76.8015 1108.04 78.2051C1111.08 79.6087 1115.76 81.0123 1122.08 82.4159C1129.33 84.2874 1135.24 86.1589 1139.8 88.0303C1144.36 89.7848 1148.34 92.709 1151.73 96.8028C1155.24 100.78 1157.05 106.16 1157.17 112.944C1157.17 118.676 1155.53 123.822 1152.26 128.384C1149.1 132.829 1144.48 136.338 1138.39 138.911C1132.43 141.484 1125.47 142.771 1117.52 142.771Z"
          fill="#1E1E1E"
        />
      </svg>
    </>
  );
  return (
    <>
      <div className={styles.container}>
        <div className={styles.titleWrapper}>
          {generateTitleContainer("employees", t("corporateEmployees"))}
          {generateTitleContainer("students", t("CampusStudents"))}
        </div>
        <p className={styles.description}>{t("testimonialsDesc")}</p>
        {renderSlider()}
        {activeContent === "students" && (
          <>
            <div className={styles.fortImageWrapper}>
              <LazyLoadImage
                alt="fort"
                src={fort}
                className={styles.fortImage}
              />
            </div>
          </>
        )}
        {activeContent === "employees" && (
          <>
            <div className={styles.backgroundText}>{backgroundText()}</div>
          </>
        )}
        {(activeContent === "employees" || !isResponsive) && (
          <>
            <div className={styles.leafPattern}>
              <LazyLoadImage alt="leaf" src={leaf} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default withTranslation("home")(TestimonialSlider);
